import * as Yup from 'yup'
import i18n from '../../i18n'
import { VALIDATION_MESSAGES } from '../../utils/translation-constants'
import validationConfig from 'custom/config/validation.config.json'
const cardLessCashConfig = validationConfig['cardLessCash']

export const SendToMobileSchema = (t) => {
  return Yup.object().shape({
    accountNumber: Yup.string().required(t(VALIDATION_MESSAGES.REQUIRED)),
    serviceId: Yup.string().required(t(VALIDATION_MESSAGES.REQUIRED)),
    mobileNumber: Yup.string()
      .required(t(VALIDATION_MESSAGES.REQUIRED))
      .matches(/^(26)?[0][0-9]{9}$/, t(VALIDATION_MESSAGES.MOBILE_NUMBER)),
    remarks: Yup.string().min(4, 'Minimuim 4 Characters'),
    transferAmount: Yup.string()
      .matches(/^(\d+|\d{1,3}(,\d{3})*)(\.\d+)?$/, t(VALIDATION_MESSAGES.NUMBERS))
      .required(t(VALIDATION_MESSAGES.REQUIRED)),
  })
}
const ValidatePhoneNo = cardLessCashConfig['isPhoneNoRequired']
  ? {
      mobileNumber: Yup.string().required(i18n.t(VALIDATION_MESSAGES.RECEIVER_MOBILE_NO)),
    }
  : {
      mobileNumber: Yup.string().optional(),
    }

const ValidateRemarks = cardLessCashConfig['isRemarksRequired']
  ? {
      remarks: Yup.string()
        .required(i18n.t(VALIDATION_MESSAGES.REMARK))
        .min(4, i18n.t(VALIDATION_MESSAGES.MINIUM_CHAR)),
    }
  : {
      remarks: Yup.string().optional(),
    }

const ValidateExpiry = cardLessCashConfig['isExpiryRequired']
  ? {
      expiry: Yup.string().required(i18n.t(VALIDATION_MESSAGES.VALIDITY)),
    }
  : {
      expiry: Yup.string().optional(),
    }

const ValidateAmount = cardLessCashConfig['isAmountRequired']
  ? {
      transferAmount: Yup.string().required(i18n.t(VALIDATION_MESSAGES.AMOUNT)),
    }
  : {
      transferAmount: Yup.string().optional(),
    }

export const CardLessSchema = (t) => {
  return Yup.object().shape({
    ...ValidatePhoneNo,
    ...ValidateRemarks,
    ...ValidateExpiry,
    ...ValidateAmount,
  })
}
